import { ImgHTMLAttributes } from 'react';

import { useDependencies } from '../../../dependencies';

const DEFAULT_AVATAR_URL = 'https://assets.urbansitter.com/static/img/us-default-avatar-320.png';

type Props = ImgHTMLAttributes<HTMLImageElement>;

const Avatar = ({ className }: Props): JSX.Element => {
  const { stores } = useDependencies();
  const avatar = stores.user.user?.pictureUrl ?? DEFAULT_AVATAR_URL;

  return (
    <img src={avatar} alt='' className={`${className !== undefined ? className : ''} w-9 h-9 inline-block rounded-full object-cover`} />
  );
};

export { Avatar };
